(function () {
  'use strict';

  const params = new URLSearchParams(window.location.search);

  const country = params.get('country');
  const spo = params.get('spo');
  const phone = params.get('phone');

  // Si no existe ningún parámetro, no hacemos nada.
  if (!country && !spo && !phone) {
    return;
  }

  // Construimos los atributos que realmente existen.
  const newAttributes = {};

  if (country) {
    newAttributes.country = country;
  }

  if (spo) {
    newAttributes.spo = spo;
    newAttributes.__aff_ref = spo;
  }

  if (phone) {
    newAttributes.phone = phone;
  }

  // Obtenemos el carrito actual para conservar
  // cualquier otro atributo existente.
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      const currentAttributes = cart.attributes || {};

      const attributes = {
        ...currentAttributes,
        ...newAttributes
      };

      return fetch(
        KROWN.settings.routes.cart_update_url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: attributes
          })
        }
      );
    })
    .then(response => response.json())
    .then(cart => {
      console.log(
        'Atributos URL guardados en el carrito:',
        cart.attributes
      );
    })
    .catch(error => {
      console.error(
        'Error al guardar los atributos de la URL:',
        error
      );
    });

})();